import type { ReploAnnouncementTag } from "schemas/generated/announcement";

import { announcementRouter } from "@v2/trpc/routes/announcement";

export const useListAnnouncements = ({
  tags,
  limit,
}: {
  tags?: ReploAnnouncementTag[];
  limit?: number;
}) => {
  const { data, isLoading } = announcementRouter.list.useQuery(
    { tags, limit },
    {
      refetchOnMount: "always",
    },
  );
  const announcements = data?.announcements ?? [];

  return {
    announcements,
    isLoading,
  };
};
